import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import { browserHistory } from "react-router";
import Auth from "../auth/Auth";
import { translate } from '../base/Translation';

export default class ErrorNew extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_error: "/error/save/new",
		});

		this.state = {
			error: null
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData() {
		this.setState({
			error: {
				code: "",
				component: "",
				state_before: "",
				required_state: "",
				type: "",
				points: 0,
				negative_points: 0,
				group: "",
				simulation_type: "",
				error_db: this.props.params.error_db_ID
			}
		});
	}

	onSave(evt) {
		this.api.request({
			route: "save_error",
			data: this.state.error,
			created: (response) => {
				browserHistory.push("/error_dbs/" + this.props.params.error_db_ID);
			}
		});
	}

	onChange(evt) {
		let newError = this.state.error;
		newError[evt.target.name] = evt.target.value;
		this.setState({ error: newError });
	}

	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	render() {

		if (this.state.error === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (
			<Page>
				<PageHeader title={translate("Pridať chybu")} />
				<PageBody>
					<Row>
						<Col lg={12}>
							<Panel header={translate("Základné")}>
								<Row>
									<Col sm={12} md={6}>
										<FormGroup>
											<ControlLabel>{translate("Kód chyby")}</ControlLabel>
											<FormControl defaultValue={this.state.error.code} name="code" onChange={this.onChange.bind(this)} />
										</FormGroup>
										<FormGroup>
											<ControlLabel>{translate("Proces / komponent / parameter")}</ControlLabel>
											<FormControl defaultValue={this.state.error.component} name="component" onChange={this.onChange.bind(this)} />
										</FormGroup>
										<FormGroup>
											<ControlLabel>{translate("Stav pred testom")}</ControlLabel>
											<FormControl defaultValue={this.state.error.state_before} name="state_before" onChange={this.onChange.bind(this)} />
										</FormGroup>
										<FormGroup>
											<ControlLabel>{translate("Požadovaný stav")}</ControlLabel>
											<FormControl defaultValue={this.state.error.required_state} name="required_state" onChange={this.onChange.bind(this)} />
										</FormGroup>
										<FormGroup style={{ display: "none" }}>
											<ControlLabel>{translate("Typ chyby")}</ControlLabel>
											<FormControl defaultValue={this.state.error.type} name="type" onChange={this.onChange.bind(this)} />
										</FormGroup>
									</Col>
									<Col sm={12} md={6}>
										<FormGroup>
											<ControlLabel>{translate("Skupina chýb")}</ControlLabel>
											<FormControl defaultValue={this.state.error.group} name="group" onChange={this.onChange.bind(this)} />
										</FormGroup>
										<FormGroup>
											<ControlLabel>{translate("Spôsob simulácie")}</ControlLabel>
											<FormControl defaultValue={this.state.error.simulation_type} name="simulation_type" onChange={this.onChange.bind(this)} />
										</FormGroup>
										<Row>
											<Col sm={12} md={6}>
												<FormGroup>
													<ControlLabel>{translate("Body")}</ControlLabel>
													<FormControl defaultValue={this.state.error.points} name="points" onChange={this.onChange.bind(this)} />
												</FormGroup>
											</Col>
											<Col sm={12} md={6}>
												<FormGroup>
													<ControlLabel>{translate("Body ak neúspešné")}</ControlLabel>
													<FormControl defaultValue={this.state.error.negative_points} name="negative_points" onChange={this.onChange.bind(this)} />
												</FormGroup>
											</Col>
										</Row>
									</Col>
								</Row>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/error/ErrorNew.js